<template>
    <div class="main" v-show="isContractAuth">
        <div class="main-home">
            <img
                @click="goHome"
                src="@/assets/images/user/house/home-jg.png"
                alt=""
            />
        </div>
        <div class="main-top" :style="{'height':(objMemorandumInfo.new_area ||  objMemorandumInfo.new_roomtype || objMemorandumInfo.new_housetype)?'10rem':'9.2rem'}">
            <div
                v-if="objMemorandumInfo.is_change == 0"
                class="main-top-contract"
            >
                正式合同
            </div>
            <div v-else class="main-top-contract">项目变更</div>
            <div class="main-top-number">{{ objMemorandumInfo.new_code }}</div>
            <div class="main-top-address">
                {{ objMemorandumInfo.new_address }}
            </div>
            <div class="main-top-square" v-if="objMemorandumInfo.new_area ||  objMemorandumInfo.new_roomtype || objMemorandumInfo.new_housetype">
                <span>{{ objMemorandumInfo.new_area }}m²</span>
                <p v-if="objMemorandumInfo.new_roomtype"></p>
                <span>{{ objMemorandumInfo.new_roomtype }}</span>
                <p v-if="objMemorandumInfo.new_housetype"></p>
                <span>{{ objMemorandumInfo.new_housetype }}</span>
            </div>
        </div>
        <div class="main-content">
            <div class="main-content-title-001">合同信息</div>
            <div class="underline"></div>
            <div class="main-content-001-content">
                <span>舒适家顾问:</span>
                <span
                    >{{ objMemorandumInfo.sign_user.name }}
                    <!--{{ objMemorandumInfo.sign_user.phone }}-->
                </span
                >
                <!-- <a class="a" :href="'tel:' + objUserInfo.phone">
          <van-icon name="phone" size="17" color="#fff" />
        </a> -->
                <div @click="codeShow = true" class="a">
                    <img
                        src="@/assets/images/user/house/electronic_contract.png"
                        alt=""
                    />
                </div>
            </div>
            <div class="underline"></div>
            <div class="main-content-001-content-price mt14">
                <span>项目类型：</span>
                <span>{{ objMemorandumInfo.important.new_projecttype }}</span>
            </div>
            <!-- <div class="main-content-001-content-price flc">
        <span>系统安装总价：</span>
        <span>200元</span>
      </div>
      <div class="main-content-001-content-price">
        <span>设备销售总价：</span>
        <span>30000元</span>
      </div> -->
            <div v-if="objMemorandumInfo.is_change == 0 && objMemorandumInfo.hidden_amount != 1" class="main-content-001-content-price flc">
                <span>合同总金额：</span>
                <span>{{ objMemorandumInfo.new_totalamount }}元</span>
            </div>
            <div v-if="objMemorandumInfo.is_change != 0 && objMemorandumInfo.hidden_amount != 1" class="main-content-001-content-price flc">
                <span>原合同总金额：</span>
                <span>{{ objMemorandumInfo.old_totalamount }}元</span>
            </div>
            <div v-if="objMemorandumInfo.is_change == 1 && objMemorandumInfo.hidden_amount != 1" class="main-content-001-content-price mt14">
                <span>{{ objMemorandumInfo.new_ischarge == 1 ? "收款：" : "退款：" }}</span>
                <span>{{ objMemorandumInfo.new_actualamount }}元</span>
            </div>
            <div v-if="objMemorandumInfo.is_change == 1 && objMemorandumInfo.hidden_amount != 1" class="main-content-001-content-price flc">
                <span>变更后合同金额：</span>
                <span>{{ objMemorandumInfo.new_totalamount }}元</span>
            </div>
            <div v-if="objMemorandumInfo.is_change == 1" class="main-content-001-content-price mt14">
                <span>变更原因：</span>
                <span>{{ objMemorandumInfo.new_reason }}</span>
            </div>
            <div v-if="objMemorandumInfo.is_change == 1" class="main-content-001-content-price-a flc">
                <span class="flc-ti-title">变更描述：</span>
                <span>{{ objMemorandumInfo.new_memo }}</span>
            </div>
            <!-- <div class="main-content-001-content-price">
        <span>收款渠道：</span>
        <span>暖通</span>
      </div> -->
            <!-- <div class="main-content-001-content-price flc">
        <span>收款方式：</span>
        <span>支付宝</span>
      </div> -->
            <!-- <div class="main-content-001-content-price">
        <span>预计开工日期：</span>
        <span>2022-02-23</span>
      </div>
      <div class="main-content-001-content-price flc">
        <span>预计完工日期：</span>
        <span>2022-12-23</span>
      </div> -->
            <div class="underline" style="margin-top: 14px"></div>
            <div class="main-content-title-002">
                <div class="main-content-title-002-title">设备详情</div>
                <div class="main-content-title-002-list">
                    <div
                        v-for="(item, index) of equipment"
                        :key="index"
                        class="item-list"
                    >
                        <div class="item-list-img">
                            <img :src="item.img" alt="" />
                        </div>
                        <div class="item-list-name-price">
                            <span>{{ item.cate }}</span>
                            <span>{{ item.name }}</span>
                            <!-- <span>¥ 6500</span> -->
                        </div>
                        <div class="item-list-num">
                            <span>x{{ item.num }}</span>
                        </div>
                        <div
                            v-if="
                                objMemorandumInfo.is_change == 1 && item.is_add
                            "
                            class="new-add"
                        >
                            新增
                        </div>
                    </div>
                    <div
                        v-if="Sentences"
                        @click="seeMoreSentences"
                        class="more"
                    >
                        查看更多
                    </div>
                    <div
                        v-if="Sentences_s"
                        @click="seeMoreSentences"
                        class="more"
                    >
                        收起
                    </div>
                </div>
            </div>
            <!-- <div class="main-content-title-003">
        <div class="main-content-title-003-title">合同相关附件</div>
        <div class="main-003-list">
          <div
            v-for="(item, index) of arrFile"
            :key="index"
            class="main-003-list-item-list"
            @click="previewImage(arrFile, index)"
          >
            <img :src="item" alt="" />
          </div>
        </div>
      </div> -->
            <template v-if="showInfo == 2 ||showInfo == 3">
                <share :isFixed="isFixed" track-action="share_contract" />
            </template>
        </div>

        <!-- <div class="download">
      <div @click="downloadContracts" class="btn-download">合同下载</div>
    </div> -->
        <div v-if="codeShow" class="qr-code">
            <div class="qr-code-service">
                <div class="qr-code-service-font48">
                    {{ objMemorandumInfo.sign_user.name }}
                </div>
                <img :src="objMemorandumInfo.sign_user.qr_code" alt="" />
                <div class="qr-code-service-font32">
                    请长按二维码添加专属顾问企业微信
                </div>
                <div @click="codeShow = false" class="qr-code-service-font28">
                    关闭
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getMemorandumInfo,
    downloadContract,
    getTeamsv2,
} from "@/js/house/index";
import { ImagePreview } from "vant";
import share from "../../../member/v2/components/share.vue";
import { log } from "@antv/g2plot/lib/utils";
import {getReportShare} from "@/js/member/mynews";

export default {
    components: {
        share,
    },
    data() {
        return {
            isContractAuth:false,
            isFixed: true,
            codeShow: false,
            objUserInfo: {
                job_number: [],
            }, //用户信息
            pdfShow: false,
            nSwiperIndex: 0, //轮播图索引
            objMemorandumInfo: {
                sign_user: {
                    rel_group_name: "",
                },
                important: {
                    new_project: "",
                },
            }, //所有信息
            objMachine: {}, //主机信息
            equipment: [], //设备列表
            equipment_s: [], // 设备列表 查看更多
            Sentences: false,
            Sentences_s: false,
            objDistribution: {}, //输配
            objControl: {}, //控制器
            objOtherMachine: {}, //辅材
            objOther: {}, //人工及其他
            nContractId: this.$route.query.contractId || this.$route.query.contractid, //合同id
            changeId: this.$route.query.changeId, //合同变更id
            remove: this.$route.query.remove, //合同变更id
            objImportantInfo: {}, //重要信息
            arrFile: [], //合同图片
            objAccount: {
                new_name: "",
                new_area: "",
                new_roomnumber: "",
                new_hall: "",
                new_toilet: "",
                new_kitchen: "",
                new_housetype_name: "",
            },
            contractIs: 0,
            showInfo: "",
            shareTimeLog:null,//分享日志记录
        };
    },
    created() {
        this.$store.commit("loadSkeleton", { bool: true }); // 页面loading开启
        $init(()=>{
            if(this.$route.query.projectmgnid){
                this.$storage.setStorage('project_uuid',this.$route.query.projectmgnid)
            }
            if(this.$route.query.form=='wxwork'){
                this.$storage.setStorage('share_source', 'wxwork') //通知过来的
            }
            this.$oInitData.memberInfo({
                h5_user_id: this.$storage.getStorage("user_id"),
            }).then((res) => {
                this.isContractAuth=true
                this.showInfo = this.$route.query.sampleroom;
                    this.$store.dispatch("banner/getData", 10);
                    Promise.all([
                        this.getMemorandum(),
                        this.downloadContracts(),
                    ]).then((res) => {
                    });
            }).finally(f=>{
                if (this.$route.query.shareId>0) {
                    let shareData = {
                        url:window.location.href,
                        project_uuid:this.$route.query.projectmgnid || this.$route.query.project_uuid,
                        id: this.$route.query.shareId,
                    }
                    getReportShare(shareData).then(res=>{
                        shareData.log_id=res.data.data.result.log_id
                        this.shareTimeLog= setInterval(()=>{
                            getReportShare(shareData)
                        },2000)
                    })
                }
            })
        })
    },
    beforeDestroy() {
        clearInterval(this.shareTimeLog)
        this.shareTimeLog=null
    },
    computed: {
        banner() {
            return this.$store.state.banner.remark;
        },
        nTranslateX: function () {
            if (this.arrFile != undefined) {
                if (
                    this.arrFile &&
                    this.nSwiperIndex < this.arrFile.length - 1
                ) {
                    if (this.nSwiperIndex > 0) {
                        return 110 * (this.nSwiperIndex - 1) * -1;
                    } else if (this.nSwiperIndex == 0) {
                        return 0;
                    }
                }
            }
        },
    },
    methods: {
        goHome() {
            let objData = this.$route.query;
            let data = {
                sampleroom: objData.sampleroom || '',
                accountid: objData.accountid || '',
                contractid: objData.contractid || objData.contractId ||  '',
                systemuserid: objData.systemuserid || '',
                sharePersonId:objData.sharePersonId || ''
            }
            this.$router.push({
                path: "/member/v2/index/index",
                query: data
            });
        },
        previewImage(item, index) {
            console.log("111");
            ImagePreview({
                images: item,
                startPosition: index,
            });
        },
        prev(type) {
            let _that = this;
            _that.$refs[type].prev();
        },
        next(type) {
            let _that = this;
            _that.$refs[type].next();
        },
        // 轮播图滑动
        swipetwo(e) {
            this.nSwiperIndex = e;
        },
        getShow(e) {
            this.pdfShow = true;
        },
        // 下载合同
        downloadContracts() {
            downloadContract({ id: this.nContractId }).then((res) => {
                this.arrFile = res.data.data.result;
            });
        },
        seeMoreSentences() {
            this.Sentences = !this.Sentences;
            this.Sentences_s = !this.Sentences_s;
            [this.equipment, this.equipment_s] = [
                this.equipment_s,
                this.equipment,
            ];
        },
        getMemorandum() {
            console.log(this.changeId,'this.changeId')
            getMemorandumInfo({
                id: this.nContractId,
                // id: '2612df91-a0ce-4844-8f2b-0cb11099b972',
                change_id: this.changeId ? this.changeId : null,
                sampleroom: this.showInfo,
                type: (this.changeId && this.changeId!=undefined &&  this.changeId!='undefined') ? 2 : 1,
            }).then((res) => {
                this.$store.commit("loadSkeleton", { bool: false }); // 页面loading关闭
                this.objMemorandumInfo = res.data.data.result;
                if (res.data.data.result.main_machine.list.length > 3) {
                    this.Sentences = true;
                    this.equipment_s = res.data.data.result.main_machine.list;
                    res.data.data.result.main_machine.list.forEach((v, i) => {
                        if (i < 3) {
                            this.equipment.push(v);
                        }
                    });
                } else {
                    this.equipment = res.data.data.result.main_machine.list; //设备列表
                }
                this.objMachine = res.data.data.result.main_machine;
                this.objDistribution = res.data.data.result.distribution; //输配
                this.objControl = res.data.data.result.control; //控制
                this.objOtherMachine = res.data.data.result.other_machine; //辅材
                this.objOther = res.data.data.result.other; //其他
                this.objUserInfo = res.data.data.result.sign_user; //用户信息
                this.objImportantInfo = res.data.data.result.important; //重要信息
            }).catch(err=>{
                let data = {
                    "result": [],
                    "token": "fc17e083f20b82661b1f3b6804a48840"
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    .main-home {
        position: fixed;
        right: 4px;
        bottom: 188px;
        width: 112px;
        height: 112px;
        z-index: 998;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .qr-code {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.3);
        z-index: 11;
        .qr-code-service {
            position: absolute;
            bottom: 112px;
            left: 50%;
            transform: translateX(-50%);
            width: 686px;
            height: 824px;
            background: #ffffff;
            border-radius: 24px;
            display: flex;
            align-items: center;
            flex-direction: column;
            img {
                width: 440px;
                height: 440px;
                margin-bottom: 48px;
            }
            .qr-code-service-font48 {
                font-size: 48px;
                // font-weight: 500;
                color: #333333;
                margin: 96px 0 64px 0;
            }
            .qr-code-service-font32 {
                font-size: 32px;
                font-weight: 400;
                color: #999999;
            }
            .qr-code-service-font28 {
                position: absolute;
                top: -56px;
                right: 80px;
                font-size: 28px;
                font-weight: 500;
                color: #ffffff;
            }
        }
    }
    .main-top {
        position: relative;
        width: 750px;
        height: 750px;
        background: #7aa894;
        .main-top-contract {
            position: absolute;
            top: 64px;
            left: 56px;
            width: 112px;
            height: 40px;
            background: #0d53fc;
            border-radius: 21px;
            color: #ffffff;
            font-size: 22px;
            text-align: center;
            line-height: 40px;
            font-weight: 500;
        }
        .main-top-number {
            position: absolute;
            top: 74px;
            right: 64px;
            font-size: 20px;
            font-weight: 400;
            color: #ffffff;
        }
        .main-top-address {
            position: absolute;
            top: 132px;
            left: 50%;
            transform: translateX(-50%);
            width: 622px;
            height: 82px;
            font-size: 36px;
            font-weight: 500;
            color: #ffffff;
            line-height: 45px;
            display: flex;
            align-items: center;
            overflow: hidden;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        .main-top-square {
            position: absolute;
            top: 220px;
            left: 64px;
            width: 442px;
            height: 30px;
            font-size: 29px;
            font-weight: 200;
            color: #ffffff;
            line-height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            p {
                width: 2px;
                height: 22px;
                background: #ffffff;
                border-radius: 1px;
                opacity: 0.7;
            }
        }
    }
    .main-content {
        position: relative;
        width: 750px;
        min-height: calc(100vh - 298px);
        background: #f9f9f9;
        border-radius: 24px 24px 16px 16px;
        margin-top: calc(-750px - -298px);
        padding: 64px 32px calc(env(safe-area-inset-bottom) + 112px);
        .underline {
            width: 686px;
            height: 1px;
            background: #e5e9e7;
        }
        .main-content-title-001 {
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            margin-bottom: 30px;
            margin-left: 32px;
        }
        .main-content-001-content {
            width: 686px;
            height: 80px;
            margin: 30px 0;
            color: #333333;
            font-size: 26px;
            display: flex;
            align-items: center;
            padding: 0 32px;
            span {
                &:nth-child(2) {
                    display: inline-block;
                    border-bottom: 1px solid #000;
                    margin-left: 16px;
                }
            }
            .a {
                display: block;
                width: 48px;
                height: 48px;
                // background: #0d53fc;
                border-radius: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: auto;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .main-content-001-content-price {
            width: 686px;
            height: 80px;
            border-radius: 24px;
            color: #a4a4a4;
            font-size: 26px;
            display: flex;
            align-items: center;
            padding-left: 32px;
            margin: 16px 0;
            font-weight: 400;
        }
        .main-content-001-content-price-a {
            width: 686px;
            height: auto;
            border-radius: 24px;
            color: #a4a4a4;
            font-size: 26px;
            display: flex;
            align-items: center;
            padding-left: 32px;
            margin: 16px 0;
            font-weight: 400;
            padding: 21px 32px 21px 32px;
            .flc-ti-title {
                min-width: fit-content;
            }
        }
        .mt14 {
            margin-top: 14px;
        }
        .flc {
            background: #eff1f0;
        }
        .main-content-title-002 {
            width: 100%;
            height: auto;
            .main-content-title-002-title {
                font-size: 28px;
                color: #333333;
                font-weight: bold;
                margin-top: 64px;
                margin-bottom: 32px;
                margin-left: 16px;
            }
            .main-content-title-002-list {
                width: 100%;
                height: auto;
                .item-list {
                    position: relative;
                    width: 686px;
                    height: 208px;
                    background: #eff1f0;
                    border-radius: 24px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                    .new-add {
                        position: absolute;
                        top: 0;
                        right: 0;
                        font-size: 22px;
                        width: 96px;
                        height: 40px;
                        background: #7aa894;
                        color: #fff;
                        border-top-right-radius: 24px;
                        border-bottom-left-radius: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .item-list-img {
                        width: 188px;
                        height: 188px;
                        background: #ffffff;
                        border-radius: 12px;
                        margin-left: 10px;
                        overflow: hidden;
                        display: flex;
                        justify-content: center;
                        img {
                            // width: 100%;
                            height: 100%;
                        }
                    }
                    .item-list-name-price {
                        width: 380px;
                        height: calc(208px - 63px);
                        margin-left: 34px;
                        display: flex;
                        flex-direction: column;
                        span {
                            &:nth-child(1) {
                                font-size: 32px;
                                color: #333333;
                                margin-top: 7px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            &:nth-child(2) {
                                font-size: 26px;
                                color: #999999;
                                margin-top: 7px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            &:nth-child(3) {
                                font-size: 26px;
                                color: #333333;
                                margin-top: 7px;
                            }
                        }
                    }
                    .item-list-num {
                        width: 30px;
                        height: 208px;
                        font-size: 26px;
                        span {
                            display: inline-block;
                            margin-top: 130px;
                        }
                    }
                }
                .more {
                    width: fit-content;
                    color: #999999;
                    font-size: 24px;
                    border-bottom: 1px solid #999999;
                    margin: 32px auto 0 auto;
                }
            }
        }
        .main-content-title-003 {
            width: 100%;
            height: auto;
            margin-top: 64px;
            .main-content-title-003-title {
                color: #333333;
                font-size: 28px;
                margin-bottom: 32px;
                margin-left: 16px;
            }
            .main-003-list {
                width: 100%;
                height: auto;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .main-003-list-item-list {
                    width: 200px;
                    height: 200px;
                    background: #eff1f0;
                    border-radius: 12px;
                    overflow: hidden;
                    margin-bottom: 44px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
    .download {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 750px;
        height: 180px;
        border-radius: 24px 24px 0px 0px;
        background: #ffffff;
        .btn-download {
            width: 686px;
            height: 72px;
            background: #355d4b;
            border-radius: 36px;
            margin: 20px auto 0 auto;
            font-size: 24px;
            text-align: center;
            line-height: 72px;
            color: #ffffff;
        }
    }
}
</style>
